export const GLOBAL_MODAL_SHOW = "GLOBAL_MODAL_SHOW";
export const GLOBAL_MODAL_DISMISS = "GLOBAL_MODAL_DISMISS";

export const CHANGE_MOBILEVIEW_FLAG = "CHANGE_MOBILEVIEW_FLAG";

export const SHOW_CART = "SHOW_CART";
export const HIDE_CART = "HIDE_CART";
export const TOGGLE_CART_VISIBILITY = "TOGGLE_CART_VISIBILITY";

export const SELECTION_RESET = `SELECTION_RESET`;

export const UPDATE_SEARCHDATA_IN_SESSION_STORAGE = `UPDATE_SEARCHDATA_IN_SESSION_STORAGE`;

export const GET_ROOM_RESULTS_REQUEST = `GET_ROOM_RESULTS_REQUEST`;
export const GET_ROOM_RESULTS_SUCESS = `GET_ROOM_RESULTS_SUCESS`;
export const GET_ROOM_RESULTS_FAIL = `GET_ROOM_RESULTS_FAIL`;
export const RESET_ROOM_RESULTS = `RESET_ROOM_RESULTS`;

export const GET_REGION_RESULTS_REQUEST = `GET_REGION_RESULTS_REQUEST`;
export const GET_REGION_RESULTS_SUCCESS = `GET_REGION_RESULTS_SUCCESS`;
export const GET_REGION_RESULTS_FAIL = `GET_REGION_RESULTS_FAIL`;

export const CHANGE_DISPLAY_ROOM = `CHANGE_DISPLAY_ROOM`;
export const RESET_DISPLAY_ROOM = `RESET_DISPLAY_ROOM`;

export const RESET_RATE_SELECTION = `RESET_RATE_SELECTION`;
export const RATE_SELECTED = `RATE_SELECTED`;
export const RATE_UNSELECTED = `RATE_UNSELECTED`;
export const SORT_BY_LOWEST_PRICE = "SORT_BY_LOWEST_PRICE";

export const CHECKIN_DATE = "CHECKIN_DATE";
export const CHECKOUT_DATE = "CHECKOUT_DATE";

export const PAX_LOADED = `PAX_LOADED`;
export const PAX_REMOVED = "PAX_REMOVED";
export const SELECTED_PAX_INDEX_CHANGE = `SELECTED_PAX_INDEX_CHANGE`;
export const RESET_SELECTED_PAX_INDEX = `RESET_SELECTED_PAX_INDEX`;
export const RESET_PAX_LIST = `RESET_PAX_LIST`;

export const SELECTED_ROOMS = `SELECTED_ROOMS`;
export const ADD_SELECTED_ROOM = `ADD_SELECTED_ROOM`;
export const REMOVE_SELECTED_ROOM = `REMOVE_SELECTED_ROOM`;

export const SELECTED_HOTEL_ID = `SELECTED_HOTEL_ID`;
export const SELECTED_REGION_ID = `SELECTED_REGION_ID`;
export const SELECTED_CITY_CODE = `SELECTED_CITY_CODE`;
export const SELECTED_DEAL_ID = `SELECTED_DEAL_ID`;

export const CHANGE_LANG = `CHANGE_LANG`;
export const CHANGE_VIEW_DIRECTION = `CHANGE_VIEW_DIRECTION`;

export const CONFIG_SUCCESS = "CONFIG_SUCCESS";
export const CONFIG_FAIL = "CONFIG_FAIL";

export const SIGNALR_MSG_NUMVIEWERS = "SIGNALR_MSG_NUMVIEWERS";

export const SHOW_GLOBAL_NOTIFICATION = "SHOW_GLOBAL_NOTIFICATION";
export const HIDE_GLOBAL_NOTIFICATION = "HIDE_GLOBAL_NOTIFICATION";

export const GET_ADDONS_REQUEST = `GET_ADDONS_REQUEST`;
export const GET_ADDONS_SUCESS = `GET_ADDONS_SUCESS`;
export const GET_ADDONS_FAIL = `GET_ADDONS_FAIL`;
export const SET_ADDONS_FOR_ORDER = "SET_ADDONS_FOR_ORDER";

export const GET_ADDONS_IMAGES_SUCESS = "GET_ADDONS_IMAGES_SUCESS";

export const ADDON_ADDED = `ADDON_ADDED`;
export const ADDON_REMOVED = `ADDON_REMOVED`;
export const ADDONS_CANCELED = "ADDONS_CANCELED";

export const SET_ADDONS_CUROSSEL_ROOM_NUMBER =
  "SET_ADDONS_CUROSSEL_ROOM_NUMBER";

export const CLUB_USER_LOGIN = "CLUB_USER_LOGIN";
export const CLUB_USER_LOGIN_FAILED = "CLUB_USER_LOGIN_FAILED";
export const CLUB_USER_LOGOUT = "CLUB_USER_LOGOUT";
export const DISCOUNT_CLUB_CONFIG = "DISCOUNT_CLUB_CONFIG";
export const CLUB_PRICES_INTERESTING = "CLUB_PRICES_INTERESTING";

export const UPDATE_PROMO_CODE = "UPDATE_PROMO_CODE";

export const SEARCH_DATA_TIMESTAMP = "SEARCH_DATA_TIMESTAMP";

export const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";

export const UPDATE_SELECTED_OPTION = "UPDATE_SELECTED_OPTION";

export const GET_DEALS_REQUEST = "GET_DEALS_REQUEST";
export const GET_DEALS_SUCCESS = "GET_DEALS_SUCESS";
export const GET_DEALS_FAIL = "GET_DEALS_FAIL";

export const GET_DEAL_DETAIL_REQUEST = "GET_DEAL_DETAIL_REQUEST";
export const GET_DEAL_DETAILS_SUCCESS = "GET_DEAL_DETAILS_SUCCESS";
export const GET_DEAL_DETAILS_FAIL = "GET_DEAL_DETAILS_FAIL";

export const GET_DEAL_SEARCH_REQUEST = "GET_DEAL_SEARCH_REQUEST";
export const GET_DEAL_SEARCH_SUCCESS = "GET_DEAL_SEARCH_SUCCESS";
export const GET_DEAL_SEARCH_FAIL = "GET_DEAL_SEARCH_FAIL";

export const GET_DEALS_RESULTS_REQUEST = "GET_DEALS_RESULTS_REQUEST";
export const GET_DEALS_RESULTS_SUCCESS = "GET_DEALS_RESULTS_SUCCESS";
export const GET_DEALS_RESULTS_FAIL = "GET_DEALS_RESULTS_FAIL";
export const SET_DEAL_SEARCH_SUCCESS = "SET_DEAL_SEARCH_SUCCESS";
export const SET_SEARCH_DATA = "SET_SEARCH_DATA";
export const FILTER_ROOMS_BY_ISPACKAGE = "FILTER_ROOMS_BY_ISPACKAGE";
export const GET_ROOM_RESULTS_DEALS_REQUEST = "GET_ROOM_RESULTS_DEALS_REQUEST";
export const RESET_ROOM_RESULTS_DEALS_REQUEST =
  "RESET_ROOM_RESULTS_DEALS_REQUEST";
export const DEAL_RATE_UNSELECTED = "DEAL_RATE_UNSELECTED";
export const DEAL_RATE_SELECTED = "DEAL_RATE_SELECTED";
export const DEAL_ANIMATION_START = "DEAL_ANIMATION_START";
export const DEAL_ANIMATION_END = "DEAL_ANIMATION_END";
export const GET_DEAL_SEARCH_RESET = "GET_DEAL_SEARCH_RESET";
export const RESET_SELECTED_DEAL = "RESET_SELECTED_DEAL";

export const IS_IE = "IS_IE";
export const IS_IOS = "IS_IOS";

export const UPDATE_SELECTED_ROOM_CATEGORY = "UPDATE_SELECTED_ROOM_CATEGORY";
export const RESET_SELECTED_ROOM_CATEGORY = "UPDATE_SELECTED_ROOM_CATEGORY";

export const START_CONTACT_US_REQUEST = "START_CONTACT_US_REQUEST";
export const CONTACT_US_REQUEST_HAS_SUCCEED = "CONTACT_US_REQUEST_HAS_SUCCEED";
export const CONTACT_US_REQUEST_HAS_FAILED = "CONTACT_US_REQUEST_HAS_FAILED";

export const SET_CURRENCY = `SET_CURRENCY`;
export const GET_CURRENCIES_REQUEST = `GET_CURRENCIES_REQUEST`;
export const GET_CURRENCIES_SUCCESS = `GET_CURRENCIES_SUCCESS`;
export const GET_CURRENCIES_FAILED = `GET_CURRENCIES_FAILED`;
export const GET_MOCK_CURRENCIES_SUCCESS = `GET_MOCK_CURRENCIES_SUCCESS`;

export const SET_COUNTRY = "SET_COUNTRY";
export const GET_COUNTRIES_REQUEST = "GET_COUNTRIES_REQUEST";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILED = "GET_COUNTRIES_FAILED";

export const SET_REGISTRATION_DATA = "SET_REGISTRATION_DATA";

export const START_RECEIVING_PAYMENT_URL = "START_RECEIVING_PAYMENT_URL";
export const GET_PAYMENT_URL_SUCCEED = "GET_PAYMENT_URL_SUCCEED";
export const GET_PAYMENT_URL_FAILED = "GET_PAYMENT_URL_FAILED";
export const GET_PAYMENT_FINISHED = "GET_PAYMENT_FINISHED";

export const SET_ORDER_SUMMARY = "SET_ORDER_SUMMARY";

export const START_SETTING_RESERVATION = "START_SETTING_RESERVATION";
export const SET_RESERVATION_SUCCEED = "SET_RESERVATION_SUCCEED";
export const SET_RESERVATION_FAILED = "SET_RESERVATION_FAILED";

export const RESET_STORE = "RESET_STORE";
export const SET_TOTAL_AMOUNT_TO_PAY = "SET_TOTAL_AMOUNT_TO_PAY";
export const SET_TOTAL_CLUB_AMOUNT_TO_PAY = "SET_TOTAL_CLUB_AMOUNT_TO_PAY";
export const SET_ORDER_CURRENCY = "SET_ORDER_CURRENCY";

export const GET_CLUB_LOGGED_USER_DATA = "GET_CLUB_LOGGED_USER_DATA";
export const GET_CLUB_LOGGED_SUCCESS = "GET_CLUB_LOGGED_SUCCESS";
export const GET_CLUB_LOGGED_FAIL = "GET_CLUB_LOGGED_FAIL";

export const PAYPAL_PROXY_SUCCEED = "PAYPAL_PROXY_SUCCEED";
export const START_PAYPAL_PROXY = "START_PAYPAL_PROXY";
export const PAYPAL_PROXY_FAILED = "PAYPAL_PROXY_FAILED";

export const PROMO_CODE_VALIDATION = "PROMO_CODE_VALIDATION";

export const SET_ACTIVE_BREAD_CRUMB = "SET_ACTIVE_BREAD_CRUMB";

export const OPEN_SEARCHBOX_MODAL = "OPEN_SEARCHBOX_MODAL";
export const CLOSE_SEARCHBOX_MODAL = "CLOSE_SEARCHBOX_MODAL";

export const THUMBNAIL_DISPLAY = "THUMBNAIL_DISPLAY";

export const GET_PLACE_HOLDERS_REQUEST = "GET_PLACE_HOLDERS_REQUEST";
export const GET_PLACE_HOLDERS_SUCCESS = "GET_PLACSE_HOLDERS_SUCCESS";
export const GET_PLACE_HOLDERS_FAILED = "GET_PLACE_HOLDERS_FAILED";

export const GET_ANALYTICS_PLACE_HOLDERS_REQUEST =
  "GET_ANALYTICS_PLACE_HOLDERS_REQUEST";
export const GET_ANALYTICS_PLACE_HOLDERS_SUCCESS =
  "GET_ANALYTICS_PLACSE_HOLDERS_SUCCESS";
export const GET_ANALYTICS_PLACE_HOLDERS_FAILED =
  "GET_ANALYTICS_PLACE_HOLDERS_FAILED";
export const CLEAR_ANALYTICS_PLACE_HOLDERS = "CLEAR_ANALYTICS_PLACE_HOLDERS";

export const TOGGLE_EXPANDBLE_VIEW = "TOGGLE_EXPANDBLE_VIEW";
export const SHOW_EXPANDED_VIEW_BY_DEFAULT = "SHOW_EXPANDED_VIEW_BY_DEFAULT";
export const TOGGLE_EXPANDBLE_VIEW_FOR_ROOM = "TOGGLE_EXPANDBLE_VIEW_FOR_ROOM";

export const GET_ROOM_FILTERS_SUCCESS = "GET_ROOM_FILTERS_SUCCESS";
export const RESET_ROOM_FILTERS_SUCCESS = "RESET_ROOM_FILTERS_SUCCESS";
export const GET_PLAN_FILTERS_SUCCESS = "GET_PLAN_FILTERS_SUCCESS";
export const GET_MAX_PRICE_FILTERS_SUCCESS = "GET_MAX_PRICE_FILTERS_SUCCESS";
export const GET_MIN_PRICE_FILTERS_SUCCESS = "GET_MIN_PRICE_FILTERS_SUCCESS";
export const SET_REGION_FILTERS_SUCCESS = "SET_REGION_FILTERS_SUCCESS";
export const SET_HOTEL_FILTERS_SUCCESS = "SET_HOTEL_FILTERS_SUCCESS";

export const SET_USER_COMMENTS = "SET_USER_COMMENTS";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js